import axios from "axios";

const baseURL = "https://report.shipday.com";

export default axios.create({
    baseURL: baseURL
});
